/* Renders admin-authored HTML safely (DOMPurify-sanitized on render). */
import { useMemo } from "react";
import DOMPurify from "dompurify";

export default function RichText({ html, className = "prose", style }) {
  const clean = useMemo(() => DOMPurify.sanitize(html || ""), [html]);
  return <div className={className} style={style} dangerouslySetInnerHTML={{ __html: clean }} />;
}
